<template>
  <div class="d-inline-block">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn icon
               color="success"
               v-on="on"
               @click="onClickConfirmar">
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </template>
      <span>Aprovar contratação</span>
    </v-tooltip>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import ContratacaoService from '../contratacao-frete-service';

export default {
  props: {
    contratacao: Object,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    onClickCancelar() {
      if (this.validateForm()) {
        return;
      }
      this.cancelar();
    },
    confirmar() {
      this.loading = true;
      ContratacaoService.aprovar(this.contratacao.id)
        .then(() => {
          this.$toast('Confirmação enviada', { color: 'success' });
          this.$emit('movimentar');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickConfirmar() {
      this.$refs.confirm.open('Você deseja confirmar a contração?',
        'A confirmação será enviada ao embarcador e esta operação não poderá ser desfeita!',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.confirmar();
        });
    },
  },
  validations: {
    motivoRecusa: {
      required,
    },
  },
};
</script>
